/**
 * Search synonym dictionary for intelligent product search
 * Maps common search terms to their synonyms to improve search relevance
 * Comprehensive fashion-related synonyms for better search results
 */
export const SEARCH_SYNONYMS: Record<string, string[]> = {
  // Footwear
  shoes: [
    "shoe",
    "sneaker",
    "sneakers",
    "boots",
    "boot",
    "loafers",
    "loafer",
    "heels",
    "sandals",
    "sandal",
    "trainer",
    "trainers",
    "running shoes",
    "sports shoes",
    "footwear",
    "athletic shoes",
    "casual shoes",
    "formal shoes",
    "high heels",
    "flats",
    "pumps",
    "oxfords",
    "derby",
    "moccasins",
    "espadrilles",
    "flip flops",
    "slides",
    "clogs",
    "ankle boots",
    "knee boots",
    "combat boots",
    "hiking boots",
    "work boots",
  ],
  sneakers: [
    "sneaker",
    "shoes",
    "trainers",
    "athletic shoes",
    "running shoes",
    "sports shoes",
    "kicks",
    "tennis shoes",
    "gym shoes",
  ],
  boots: [
    "boot",
    "ankle boots",
    "knee boots",
    "combat boots",
    "hiking boots",
    "work boots",
    "winter boots",
    "rain boots",
    "chelsea boots",
  ],
  
  // Tops
  tshirt: [
    "tee",
    "t-shirt",
    "tshirt",
    "tees",
    "shirt",
    "oversized tshirt",
    "t shirt",
    "tank top",
    "polo",
    "polo shirt",
    "casual shirt",
  ],
  shirt: [
    "shirt",
    "tshirt",
    "t-shirt",
    "tee",
    "blouse",
    "top",
    "button down",
    "button-up",
    "dress shirt",
    "casual shirt",
    "formal shirt",
  ],
  hoodie: [
    "hoodie",
    "sweatshirt",
    "pullover",
    "hooded sweatshirt",
    "zip up hoodie",
    "jacket",
  ],
  sweater: [
    "sweater",
    "pullover",
    "jumper",
    "cardigan",
    "knit",
    "wool sweater",
    "cashmere",
  ],
  jacket: [
    "hoodie",
    "sweater",
    "coat",
    "outerwear",
    "blazer",
    "cardigan",
    "windbreaker",
    "bomber jacket",
    "denim jacket",
    "leather jacket",
    "trench coat",
    "parka",
    "puffer jacket",
    "rain jacket",
  ],
  blazer: [
    "blazer",
    "sport coat",
    "suit jacket",
    "formal jacket",
    "business jacket",
  ],
  
  // Bottoms
  pant: [
    "pants",
    "trouser",
    "trousers",
    "jeans",
    "denim",
    "cargos",
    "cargo",
    "joggers",
    "jogger",
    "chinos",
    "slacks",
    "dress pants",
    "formal pants",
  ],
  jeans: [
    "jeans",
    "denim",
    "denim jeans",
    "blue jeans",
    "skinny jeans",
    "straight jeans",
    "bootcut jeans",
    "wide leg jeans",
  ],
  joggers: [
    "joggers",
    "jogger",
    "sweatpants",
    "track pants",
    "athletic pants",
    "sport pants",
  ],
  shorts: [
    "shorts",
    "short",
    "bermuda shorts",
    "cargo shorts",
    "athletic shorts",
    "swim shorts",
  ],
  
  // Bags & Accessories
  bag: [
    "handbag",
    "purse",
    "backpack",
    "shoulder bag",
    "sling bag",
    "tote",
    "tote bag",
    "clutch",
    "wallet",
    "crossbody bag",
    "messenger bag",
    "duffel bag",
    "travel bag",
    "gym bag",
    "laptop bag",
    "briefcase",
  ],
  backpack: [
    "backpack",
    "rucksack",
    "knapsack",
    "school bag",
    "laptop backpack",
  ],
  wallet: [
    "wallet",
    "purse",
    "billfold",
    "card holder",
    "money clip",
  ],
  
  // Eyewear
  glasses: [
    "sunglasses",
    "shades",
    "specs",
    "goggles",
    "eyewear",
    "spectacles",
    "reading glasses",
    "prescription glasses",
    "aviator",
    "wayfarer",
  ],
  sunglasses: [
    "sunglasses",
    "shades",
    "sun glasses",
    "aviator sunglasses",
    "wayfarer sunglasses",
  ],
  
  // Watches & Jewelry
  watch: [
    "timepiece",
    "wristwatch",
    "clock",
    "smartwatch",
    "analog watch",
    "digital watch",
    "sports watch",
    "luxury watch",
  ],
  jewelry: [
    "jewellery",
    "accessories",
    "ornaments",
    "jewelry",
    "fashion jewelry",
  ],
  ring: [
    "band",
    "wedding ring",
    "engagement ring",
    "finger ring",
    "signet ring",
  ],
  necklace: [
    "pendant",
    "chain",
    "choker",
    "locket",
    "collar",
  ],
  earrings: [
    "earring",
    "studs",
    "hoops",
    "danglers",
    "drop earrings",
  ],
  bracelet: [
    "bracelet",
    "bangle",
    "cuff",
    "chain bracelet",
  ],
  
  // Dresses & Skirts
  dress: [
    "gown",
    "frock",
    "outfit",
    "attire",
    "evening dress",
    "casual dress",
    "maxi dress",
    "mini dress",
    "midi dress",
    "sundress",
  ],
  skirt: [
    "skirt",
    "mini skirt",
    "maxi skirt",
    "pencil skirt",
    "pleated skirt",
    "a-line skirt",
  ],
  
  // Headwear
  hat: [
    "cap",
    "beanie",
    "beret",
    "headwear",
    "baseball cap",
    "snapback",
    "trucker hat",
    "fedora",
    "bucket hat",
    "sun hat",
  ],
  cap: [
    "cap",
    "baseball cap",
    "snapback",
    "trucker hat",
    "flat cap",
  ],
  beanie: [
    "beanie",
    "knit cap",
    "winter hat",
    "stocking cap",
  ],
  
  // Underwear & Lingerie
  underwear: [
    "underwear",
    "under garments",
    "lingerie",
    "briefs",
    "boxers",
    "boxer shorts",
  ],
  bra: [
    "bra",
    "brassiere",
    "sports bra",
    "bralette",
  ],
  
  // Swimwear
  swimwear: [
    "swimwear",
    "swimsuit",
    "bikini",
    "swim trunks",
    "bathing suit",
    "swim shorts",
  ],
  bikini: [
    "bikini",
    "two piece",
    "swimsuit",
  ],
  
  // Activewear
  activewear: [
    "activewear",
    "athletic wear",
    "sportswear",
    "gym wear",
    "workout clothes",
    "fitness wear",
  ],
  leggings: [
    "leggings",
    "legging",
    "yoga pants",
    "athletic leggings",
  ],
  
  // Formal Wear
  suit: [
    "suit",
    "business suit",
    "formal suit",
    "tuxedo",
    "three piece suit",
  ],
  tie: [
    "tie",
    "neck tie",
    "bow tie",
    "cufflinks",
  ],
  
  // Seasonal
  winter: [
    "winter",
    "cold weather",
    "warm",
    "thermal",
    "fleece",
  ],
  summer: [
    "summer",
    "warm weather",
    "lightweight",
    "breathable",
  ],
  
  // Colors (common fashion searches)
  black: ["black", "dark", "ebony"],
  white: ["white", "ivory", "cream"],
  red: ["red", "crimson", "burgundy", "maroon"],
  blue: ["blue", "navy", "azure", "cobalt"],
  green: ["green", "emerald", "olive", "mint"],
  
  // Styles
  vintage: ["vintage", "retro", "classic", "antique"],
  modern: ["modern", "contemporary", "trendy", "fashionable"],
  casual: ["casual", "everyday", "relaxed", "comfortable"],
  formal: ["formal", "elegant", "dressy", "sophisticated"],
  streetwear: ["streetwear", "urban", "hip hop", "casual"],
};

